// HTML elements global variables
var resultsList;
var searchBar;
var clearButton;
var searchBtn;
var paginationList;

var MAX_CONTENT_PREVIEW_LENGTH = 10;
var RESULTS_PER_PAGE = 10;
var SEARCH_BASE_URL = "https://search.edlio.com/";

window.addEventListener("DOMContentLoaded", function(){
	resultsList = document.getElementById("results");
    searchBar = document.getElementById("search_bar");
    clearButton = document.getElementById("clear_button");
    searchBtn = document.getElementById("search_btn");
    paginationList = document.getElementById("pagination_container");

	main();
});

function main() {
    searchBar.focus();
    var schoolId = getDistrictIdOrWebsiteId();
	var searchQueryParam = getSearchQueryFromUrlParams();

	if (searchQueryParam) {
		searchBar.value = searchQueryParam;
		search(1);
		removeHidden("clear_button");
	}

    clearButton.addEventListener("click", clearResults);

    searchBtn.addEventListener("click", function() {
        search(1);
    });

    searchBar.addEventListener("keyup", function(e) {
        /* Enter KeyCode */
        if (e.keyCode === 13 ) {
            search(1);
        }

        this.value ? removeHidden("clear_button") : addHidden("clear_button");
    });
}

// if districtId has a value use it, otherwise use websiteId
function getDistrictIdOrWebsiteId() {
	var districtId = window.edlio.districtId;

	if (districtId && districtId != '0' && districtId != 0) {
		return districtId;
	}

    return window.edlio.websiteId;
}

// Hit Websearch API
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function search(page) {
	if (!searchBar.value) { 
        return searchBar.focus(); 
    }

	if (resultsList.childElementCount) { 
        addOpacity("search_content_body");
    } else { 
        resultsList.innerHTML = renderLoadingMessage();
    }

    const searchParams = new URLSearchParams({
        q: searchBar.value,
        offset: (page - 1) * RESULTS_PER_PAGE,
    });

    var projectIds = window.edlio.projectIds;

    if (projectIds && projectIds.length > 0) {
        searchParams.set('projectIds', projectIds)
    }

    var url = SEARCH_BASE_URL + getDistrictIdOrWebsiteId() + '/search?' + searchParams.toString()
    
    fetch(url)
        .then(function(response) {
            return response.json();
        })
        .then(throwIfNoSearchResults)
        .then(transformSearchResultItems)
        .then(function(body) {
            resultsList.innerHTML = body.items.map(function(item) {
                return renderSearchResult(item);
            }).reduce(function(acc, el) {
                return acc + el;
            }, "");
    
            var resultsCount = body.pagination.count;
            showResultsCount(resultsCount);
            removeOpacity("search_content_body");
            renderPagination(resultsCount, page);
        })
        .catch(function(err) {
			addHidden("count_container");
			addHidden("pagination_container");
			removeOpacity("search_content_body");
            renderNoResults();
        });
};

function transformSearchResultItems(body) {
    body.items.forEach(function(item) {
        if (item._source.WebsiteID == "DEFAULT") {
            item._source.Url = window.location.origin + item._source.Url.replace(/^.*\/\/[^\/]+/, '');
        }
    });

    return body;
}

function throwIfNoSearchResults(body) {
    if (body.items.length === 0) {
        throw new Error("No results found");
    }

    return body;
}

function getSearchQueryFromUrlParams(url) {
	const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);

    return searchParams.get('q');
}

// Rendering
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function renderSearchResult(item) {
    var bodySourceUrl = item._source.Url;
    var title = item._source.Title || item.highlight.Title[0];

    var resultBody = "";

    if (item._source.PreviewText && item._source.PreviewText.length) {
        resultBody = item._source.PreviewText;
    } else if (item.highlight && item.highlight.Text && item.highlight.Text.length) {
        item.highlight.Text.forEach(function(mention, index) {
            resultBody += mention.trim();

            if (index !== item.highlight.Text.length - 1) {
                resultBody += "...";
            }
        })
    } else {
        resultBody = item._source.Text ? getResultText(item._source.Text) : "";
    }

    var innerHTML = "<div class='result-item'>"
                  + "<div class='result-title'>"
                  + "<a href='" + bodySourceUrl + "'>" + title + "</a>"
                  + "</div>"
                  + "<div class=\"result-link\">"
                  + "<a href=" + bodySourceUrl + ">" + bodySourceUrl + "</a>"
                  + "</div>"
                  + "<div class=\"result-preview\">"
                  + resultBody
                  + "</div>"
                  + "</div>"

    return innerHTML;
}

function getResultText(rawText) {
	var text = "";

	//todo: this strips out marks - put them back in after? Too expensive to do that?
	text = stripTags(rawText);
	var firstSentence = text.split(".")[0];

	if (firstSentence.split(" ").length < MAX_CONTENT_PREVIEW_LENGTH) {
		text = firstSentence;
	} else {
		text = firstSentence.split(" ").slice(0,MAX_CONTENT_PREVIEW_LENGTH).join(" ");
		text += "&#8230";
	}
	return text;
}

function showResultsCount(resultsCount) {
	removeHidden("count_container");
	removeHidden("pagination_container");

    var resultsCountEl = document.getElementById("search_results_count_text");
    resultsCountEl.innerText = resultsCount.toString() + ' results';
    resultsCountEl.setAttribute('aria-live', 'polite');
}

function renderNoResults() {
    removeChildNodes(resultsList);
    var containerEl = document.createElement('p');
    containerEl.className = 'no-results';
    containerEl.innerHTML = 'No Results';
    containerEl.setAttribute('aria-live', 'polite');

    resultsList.appendChild(containerEl);
}

function renderLoadingMessage() { 
    return "<div class='loading'>Searching...</div>"; 
}

// Pagination
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function renderPagination(resultsCount, page) {
    removeChildNodes(paginationList);

	var pageCount = Math.ceil(resultsCount / RESULTS_PER_PAGE);
	var paginationInner = "";


    Array.from({ length: pageCount }, (_, index) => index + 1)
        .forEach(function(pageNumber) {
            var paginationButtonEl = PaginationButton({
                pageNumber: pageNumber,
                current: pageNumber === page,
                onClick: function() {
                    search(pageNumber);
                }
            });
            paginationList.appendChild(paginationButtonEl);
        })
}

function PaginationButton(params) {
    var buttonEl = document.createElement('button');
    buttonEl.className = 'pagination-button';

    if (params.current) {
        buttonEl.classList.add("current-page");
    }

    buttonEl.textContent = params.pageNumber;
    buttonEl.addEventListener('click', params.onClick);

    return buttonEl;
}

// Misc
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
function addHidden(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.add("hidden");
}

function removeHidden(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.remove("hidden");
}

function addOpacity(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.add("opaque");
}

function removeOpacity(targetElId) {
	var targetObj = document.getElementById(targetElId);
	targetObj.classList.remove("opaque");
}

function clearResults() {
    removeChildNodes(resultsList);
    searchBar.value = "";
	addHidden("clear_button");
	addHidden("count_container");
	addHidden("pagination_container");
}

function removeChildNodes(parentEl) {
    while (parentEl.firstChild) {
        parentEl.removeChild(parentEl.firstChild);
    }
}

function stripTags(html){
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
}
